import React from "react";
import { FiFacebook, FiTwitter, FiInstagram } from "react-icons/fi";

import { FooterOverlay, Newsletter } from "../../components";
import { images } from "../../constants";
import "./Footer.css";

const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    <Newsletter />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">
          Keshav Apartments, Besides Aryaman Flats, Prernatirth Derasar
          Satellite, Ahmedabad, Gujarat 380015
        </p>
        <p className="p__opensans">+91 9978113104</p>
        <p className="p__opensans">+91 9824045315</p>
      </div>

      <div className="app__footer-links_logo">
        <p className="app_footer-title">Shah-i-licious</p>
        <p className="p__opensans">
          &quot;Pop-up deliveries all week round from our happy home to yours!
          💖&quot;
        </p>
        <img
          src={images.spoon}
          className="spoon__img"
          style={{ marginTop: 15 }}
        />
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday-Friday:</p>
        <p className="p__opensans">08:00 am - 12:00 am</p>
        <p className="p__opensans">Saturday-Sunday:</p>
        <p className="p__opensans">07:00 am - 11:00 pm</p>
      </div>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">2022 Shah-i-licious. All Rights reserved.</p>
    </div>
  </div>
);

export default Footer;
